import request from "@/utils/request";

export function getSalesReport(params) {
	return request({
		url:'/oms/report/sale',
		method:'get',
		params:params
	})
}



// WEBPACK FOOTER //
// ./src/api/scm/sales-report.js